export const uk: { [key: string]: string } = {
	'Study request to course "Using Technology During War"':
		'Запит на доступ до онлайн курсу "Застосування технологій в умовах війни"',
	'Study Request was successfully sent.': 'Запит на навчання було сформовано успішно.',
	'Study Request was successfully updated.': 'Запит на навчання було успішно оновлено.',
	'Study Request status was successfully changed.':
		'Статус запиту на навчання було змінено успішно.',
	'Study request (help)': `Зв'язатись з відділом підтримки:`,
	Name: 'ПІБ або позивний',
	Email: 'Електронна адреса',
	Phone: 'Телефон',
	'Military Unit':
		'Військова частина В/Ч в форматі А0000, 0000, E0000, T0000 або 0000T',
	Unit: 'В/Ч',
	'Download request description': 'Завантажити опис',
	'Download attachment example': 'Зразок',
	Organisation: 'Організація',
	Students: 'Студенти',
	Request: 'ID Запита',
	'Request Attachments': 'Запит від військової частини',
	'Request from a military unit': 'Запит від військової частини',
	'Request from a military unit (description)':
		"Завантажте офіційний запит на благодійну організацію Dignitas Fund, у якому вказаний перелік учасників навчання (ім'я-прізвище/позивний та електронна пошта для кожного). Обов'язкова наявність печатки Вашої військової частини/організації , підпису та ПІБ відповідальної особи. Обмеження: 2 файли, розширення pdf або jpg.",
	'New Request Attachments': 'Додати нові документи',
	'Already saved attachments': 'Завантажені документи',
	Description: 'Додаткова інформація',
	Send: 'Надіслати',
	'Clean up': 'Очистити',
	'name is a required field': '"Iм\'я" є обов\'язковим полем',
	'email is a required field': '"Електронна адреса" є обов\'язковим полем',
	'.ru domain is forbidden for email': '"Електронна адреса" не може мати домен .ru',
	'cyrillic chars are forbidden for email':
		'"Електронна адреса" не може містити кирилицю',
	'duplicate student email':
		'Однакові електронні адреси для різних студентів заборонені',
	'Phone should be in next format +XXYYYXXXXXXX, e.g. +380991234567':
		'Телефон в форматі +XXYYYXXXXXXX, наприклад +380991234567',
	'phone must be a valid phone number for region UA':
		'Номер телефону має бути дійсним для регіону України',
	'phone must be a valid phone number.':
		'Номер телефону має бути дійсним для регіону України',
	'unit is a required field': "Це поле є обов'язковим для заповнення",
	'students field must have at least 1 items':
		'Поле "Студенти" має містити принаймні 1 елемент',
	'requestAttachments field must have at least 1 items':
		'Поле "Запит від військової частини" має містити принаймні 1 елемент',
	'requestAttachments field must have less than or equal to 2 items':
		'Поле "Запит від військової частини" має містити 2 або менше елементів',
	'requestAttachment example filename': 'ЗРАЗОК | Лист-звернення на доступ до курсу',
	'requestAttachment download button label': 'Скачати зразок',
	'email must be a valid email': 'Електрона адреса має бути дійсною',
	'Remove student': 'Вилучити студента',
	'Add New Student': 'Додати студента',
	'Add New Students': 'Додати списком',
	Upload: 'Завантажити',
	'Study Request Management': 'Запити',
	'Students Management': 'Студенти',
	'New Study Request': 'Новий запит',
	'Create new study request': 'Створити новий запит',
	'Submit Date': 'Дата подачі',
	Status: 'Статус',
	"Rows per page": 'Рядків на сторінці',
	'switch day/night': 'перемкнути день/ніч',
	attachment: 'Документ ',
	pending: 'В очікуванні',
	approved: 'Схвалено',
	rejected: 'Відхилено',
	deactivated: 'Деактивований',
	error: 'Помилка',
	new: 'Новий запит',
	sent: 'Зареєстрований',
	'Please wait...': 'Зачекайте будь ласка...',
	'Approve request': 'Схвалити запит',
	'I checked the request and I approve to start registration process.':
		'Я перевірив запит і даю згоду на початок процесу реєстрації.',
	Yes: 'Так',
	No: 'Ні',
	'Reject request': 'Відхилити запит',
	'Please describe the reason, why the request should be rejected.':
		'Будь ласка, опишіть причину, чому запит має бути відхилено.',
	'Please describe the reason.': 'Будь ласка, опишіть причину.',
	Reason: 'Причина',
	'Deactivation reason': 'Причина деактивація',
	Filters: 'Фільтри',
	'Please select status': 'Будь ласка оберіть статус',
	'--//--': '--//--',
	'Not Found': 'Не знайдено',
	Search: 'Пошук',
	'Search by': 'Шукати за',
	'Date from': 'Дата з',
	'Date to': 'Дата по',
	'MM/DD/YYYY': 'DD.MM.YYYY',
	'"Reason" is a required field': '"Причина" є обов\'язковим полем',
	'notes is a required field': '"Причина" є обов\'язковим полем',
	'Back to pending': 'Повернути до  "В очікуванні"',
	'Edit Study Request': 'Редагування запиту на навчання',
	'Revert to saved': 'Скинути до збереженної версії',
	'Edit Student': 'Редагування даних студента',
	Save: 'Зберегти',
	'Add Student': 'Додати студента',
	'Delete attachment': 'Видалити документ',
	'Add attachment': 'Додати документ',
	'Attachment was successfully removed.': 'Документ було успішно видалено.',
	'Attachment was added successfully.': 'Документ було додано успішно.',
	'Student was successfully updated.': 'Інформацію про студента була успішно оновлено.',
	'Student was successfully created.':
	'Інформацію про нового студента було додано успішно.',
	'Student was successfully removed.': 'Інформацію про студента було видалено успішно.',
	'Wrong Unit format.': 'Формат поля невірний.',
	'M/U': 'В/Ч',
	Copy: 'Копіювати',
	'Copy Request ID': 'Копіювати ID запита',
	'Copy Student ID': 'Копіювати ID студента',
	'Dublicate email': 'Продубльований імейл',
	All: 'Всім',
	'Switch Military Unit / Civil Organisation':
		'Переключити Військова частина / Цівільна організація',
	'Please use switch control to choose to use the Military Unit or Civil Organisation':
		'Оберіть за допомогою перемикача запит від військової частини чи іншої організації',
	'Responsible person': 'Відповідальна особа',
	'Add list of students': 'Додати перелік студентів',
	'Can be': 'Може бути',
	'Responsible person email': 'Електронна адреса відповідальної особи',
	'Responsible person Name': "Ім'я відповідальної особи",
	'Student Email': 'Електронна адреса Студента',
	'Student Name': "Ім'я Студента",
	'If you need to add many students you can add list of students to this field. One student - one line. Format: Full Name, Email':
		'Щоб додати одразу декількох студентів, внесіть кожного студента в це поле окремим рядком. Формат: ПІБ/позивний, Email',
	ID: 'ID',
	'User ID': 'ID Користувача',
	'Student ID': 'ID Студента',
	copied: 'скопійовано',
	'Request ID': 'ID Запита',
	Changes: 'Зміни',
	'Date / Time': 'Дата / Час',
	'Date / Time of change': 'Дата та час зміни',
	'History of changes': 'Історія змін',
	'Log in': 'Залогінитись',
	Logout: 'Вийти',
	'Download file': 'Скачати файл',
	'Request Basic Registration Access': 'Спрощена реєстрація',
	'ACCESS DENIED': 'Доступ заборонено!!!',
	'Basic flow was successfully accepted for':
		'Доступ до спрощеної реєстрації дозволено для',
	'Basic Flow': 'Спрощений процес',
	'Basic flow only': 'Тільки спрощений процес',
	'Basic flow email': 'Електронна адреса спрощеної форми',
	'Request from a military unit (help)': `Якщо y вас взагалі немає можливості отримати офіційний лист від військової частини з печаткою, напишіть в Signal у Відділ підтримки Victory Drones:`,
	'Back to homepage': 'На головну',
	'Study request accepted': 'Запит на навчання прийнято',
	'Yor request id:': 'Номер вашого запиту:',
	'ACTIVE': 'Активний',
	'CAPTIVITY': 'Полон',
	'BLK': 'ВЛК',
	'ILLIGAL ACTIONS': 'Протиправні дії',
	'OTHER': 'Інше',
};
